import React, { useState } from 'react';
import { ParticipatingHospitalModel } from 'lib/salesforce/types';
import classnames from 'classnames';
import LinkA11yWrapper from 'components/helpers/LinkA11yWrapper';
import { GetColumnValueProps } from './lib/SaleforceTable';

const GetParticipatingHospitalColumnValue = ({
  name,
  item,
}: GetColumnValueProps<ParticipatingHospitalModel>): React.JSX.Element => {
  const [phoneNumber] = useState(() => {
    return {
      value: {
        href: item.PhoneNumber ? `tel:${item.PhoneNumber}` : '',
        text: item.PhoneNumber,
      },
    };
  });

  const [tollFreeNumber] = useState(() => {
    return {
      value: {
        href: item.TollFreeNumber ? `tel:${item.TollFreeNumber}` : '',
        text: item.TollFreeNumber,
      },
    };
  });

  const [website] = useState(() => {
    return {
      value: {
        href: item.Website,
        text: item.Name,
      },
    };
  });

  switch (name) {
    case 'HospitalName':
      return (
        <>
          {item?.HospitalName}
          {item?.HospitalName2 ? ' ' : ''}
          {item?.HospitalName2}
        </>
      );
    case 'City':
      return <>{item?.City}</>;
    case 'State':
      return <>{item?.State}</>;
    case 'Name':
      return (
        <>
          {website ? (
            <LinkA11yWrapper
              className={classnames('text-blue-morning')}
              editable={false}
              field={website}
            />
          ) : (
            item.Name
          )}
          {phoneNumber && (
            <LinkA11yWrapper
              className={classnames('text-blue-morning', 'block')}
              editable={false}
              field={phoneNumber}
            />
          )}
          {tollFreeNumber && (
            <LinkA11yWrapper
              className={classnames('text-blue-morning', 'block')}
              editable={false}
              field={tollFreeNumber}
            />
          )}
        </>
      );
    default:
      return <></>;
  }
};

export default GetParticipatingHospitalColumnValue;
